export default {
  data() {
    return {
      baseurlAdminAppUrl: "https://go.parmonic.com/",
      isLocalhost: window.location.host.indexOf("localhost") > -1,
      localbase: `${window.location.protocol}//${window.location.host.replace(
        "8080",
        "3000"
      )}/`,
      analyticsEventsCaptureEndPoint: "",
      socialShareUrl: "",
      PublishedWebinarDataEndPoint: "https://awapi.blob.core.windows.net/awd/",
      videoPlayers: [],
      isGated: false,
      identifierKey: 0
    }
  }
}
